
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import get from 'lodash/get';

import {
    DialogAlert,
    DialogConfirm,
    IfComp,
    ToolbarCommandButton
} from '../../../core';

import { sagas as sagasMap } from '../../../map';

import {
    getDataProjectId,
    getMapLayerById ,
    useDisableEditMsg,
    useToken
} from '../../../project';

import { getActions } from '../../sagas';

import { getInfo } from '../../reducers'

import {
    INFO_TYPE_HOME,
    INFO_TYPE_OBJECT_LIST
} from '../../reducers/infoPanelType';

import {
    getObject ,
    getObjectList,
    getSourceType
} from '../../reducers/info'

import { calculateObjectKeyForDocument } from '../../reducers/document';
import useDataModelItem from '../../hooks/useDataModelItem';

import {
    useDataModelOperationDelete,
    useDataModelOperationUpdate
} from '../../hooks/useDataModelOperation';

import ObjectDetailInfo from './ObjectDetailInfo';
import DocumentPanel from '../document/DocumentPanel';

const ObjectDetailPanel = ({appActions}) => {

    const classNames = mergeStyleSets({
        ObjectDetailPanel: {
        }
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);
    const mapActions = sagasMap.getActions(dispatch);

    const dataProjectId = useSelector(state => getDataProjectId(state.project));
    const disableEditMsg = useDisableEditMsg();

    const object = useSelector(state => getObject(getInfo(state.data)));
    const objectList = useSelector(state => getObjectList(getInfo(state.data)));
    const sourceType = useSelector(state => getSourceType(getInfo(state.data)));
    const project = useSelector(state => state.project);
    const mapLayer = getMapLayerById(project, object.layerId);
    const dataModelItem = useDataModelItem(mapLayer);
    const operationDelete = useDataModelOperationDelete(dataModelItem);
    const operationUpdate = useDataModelOperationUpdate(dataModelItem);

    const token = useToken();

    React.useEffect(() => {
        if (object && object.attributes._geom) {
            handleHighlightOn();
        }
        return () => {
            handleHighlightOff();
        };
    }, [object]);

    const getObjectKey = () => {
        return calculateObjectKeyForDocument(
            object, 
            dataModelItem ? dataModelItem.attachedDocuments : null
        );
    }

    const handleHighlightOn = () => {
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE',
            {
                geoJson: object.attributes._geom
            }
        );
    }

    const handleHighlightOff = () => {
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE', {geoJsons: []}
        );
    }

    const handleBackListClick = () => {
        dataActions.setType(INFO_TYPE_OBJECT_LIST);
    }

    const handleBackSearchClick = () => {
        dataActions.setType(INFO_TYPE_HOME);
        appActions.setUiValue('activePanelName', 'search');
    }

    const handleCloseClick = () => {
        dataActions.setType(INFO_TYPE_HOME);
    }

    const handleDeleteClick = async () => {
        if (!disableEditMsg) {
            let confirm = await DialogConfirm.show(`Opravdu chcete smazat tento objekt ?`);
            if (confirm) {
                dataActions.deleteObject(
                    token, dataProjectId, dataModelItem.id, object.layerId,
                    {gid: object.attributes.gid}
                );
            }
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    const handleUpdateClick = () => {
        if (!disableEditMsg) {
            dataActions.setObjectEdit(object);
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    const handleToMapClick = () => {
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE',
            {
                geoJson: object.attributes._geom,
                zoomToFeature: true
            }
        );
    }

    let commands = [];

    if (operationDelete) {
        commands.push({
            text: 'Smazat',
            title: 'Smazat objekt',
            onClick: handleDeleteClick
        });
    }
    if (operationUpdate) {
        commands.push({
            text: 'Editovat',
            title: 'Editovat parametry objekt',
            onClick: handleUpdateClick
        });
    }
    if (object && (object.attributes._geom)) {
        commands.push({
            text: 'Do mapy',
            title: 'Zobrazit objekt ve 2D mapovém okně',
            onClick: handleToMapClick
        });
    }
    if (objectList && !sourceType) {
        if (objectList.length === 1) {
            commands.push({
                text: 'Zpět',
                title: 'Zpět na úvodní stránku Datového panelu',
                onClick: handleCloseClick
            });
        } else {
            commands.push({
                text: 'Zpět',
                title: 'Zpět na seznam objektů',
                onClick: handleBackListClick
            });
        }
    }
    if (sourceType === 'search') {
        commands.push({
            text: 'Zpět',
            title: 'Zpět na vyhledávání',
            onClick: handleBackSearchClick
        });
    }

    return (
        <Stack verticalFill className={classNames.ObjectDetailPanel} tokens={{childrenGap: 8}}>
            <IfComp cond={dataModelItem}>
                <ObjectDetailInfo
                    dataModel={dataModelItem}
                    object={object}
                />
            </IfComp>
            <IfComp cond={!dataModelItem}>
                <div>Žádné informace nejsou k dispozici</div>
            </IfComp>
            <ToolbarCommandButton
                items={commands}
            />
            <IfComp cond={dataModelItem && dataModelItem.attachedDocuments}>
                <DocumentPanel
                    objectKey={getObjectKey()}
                    readOnly={!operationUpdate}
                />
            </IfComp>
        </Stack>
    );
}

export default ObjectDetailPanel;
